export var LandingPageState;
(function (LandingPageState) {
    LandingPageState["ACTIVE"] = "ACTIVE";
    LandingPageState["ARCHIVED"] = "ARCHIVED";
    LandingPageState["PENDING"] = "PENDING";
    LandingPageState["DELETED"] = "DELETED";
    LandingPageState["FAILED"] = "FAILED";
})(LandingPageState || (LandingPageState = {}));
export var LandingPageLinkState;
(function (LandingPageLinkState) {
    LandingPageLinkState["ACTIVE"] = "ACTIVE";
    LandingPageLinkState["ARCHIVED"] = "ARCHIVED";
    LandingPageLinkState["PENDING"] = "PENDING";
    LandingPageLinkState["DELETED"] = "DELETED";
    LandingPageLinkState["GENERATION_FAILED"] = "GENERATION_FAILED";
})(LandingPageLinkState || (LandingPageLinkState = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENT"] = "PERCENT";
    DiscountType["FIXED"] = "FIXED";
    DiscountType["OTHER"] = "OTHER";
})(DiscountType || (DiscountType = {}));
export var LandingPageChannel;
(function (LandingPageChannel) {
    LandingPageChannel["PAID"] = "PAID";
    LandingPageChannel["OWNED"] = "OWNED";
})(LandingPageChannel || (LandingPageChannel = {}));
